// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__2zjo_","listItemWithLink":"List_listItemWithLink__1G3H6"};